<template>
	<StandardModal
		open
		small
		:title="$t('settings_apitokens_show_token_title')"
		@cancel="$emit('cancel')"
		class="show-token-modal"
	>
		<div class="show-token">
			<div class="token-logo">
				<NoAPITokensIcon :showBackground="false" />
			</div>
			<div class="subtitle">
				{{ $t('settings_apitokens_show_token_subtitle') }}
			</div>

			<CopyToClipboard
				:value="token"
				:tippyProps="{ offset: [0, 10] }"
				@copied="hasCopied = true"
			>
				<Input class="token" v-model="tokenValue" :readonly="true" type="text">
					<template #after>
						<CopyIcon type="regular" class="copy-icon" />
					</template>
				</Input>
			</CopyToClipboard>

			<div class="help">
				{{ $t('settings_apitokens_show_token_help') }}
			</div>
		</div>
		<template #footer-right>
			<Button primary @click="$emit('next')" :disabled="!hasCopied">
				{{ $t('common_button_close') }}
			</Button>
		</template>
	</StandardModal>
</template>

<script>
import {
	Input,
	StandardModal,
	Button,
	CopyToClipboard,
} from '@/components/common'
import { NoAPITokensIcon, CopyIcon } from '@/icons'

export default {
	props: ['token'],
	components: {
		Input,
		CopyToClipboard,
		CopyIcon,
		NoAPITokensIcon,
		StandardModal,
		Button,
	},
	data() {
		return { hasCopied: false, tokenValue: this.token }
	},
	emits: ['cancel', 'next'],
}
</script>

<style lang="scss" scoped>
@import 'src/sass/variables';

.subtitle {
	margin-bottom: 33px;
	font-family: 'Avenir-Heavy';
	font-size: 22px;
	color: var(--neutral-800);
}

.token {
	font-family: 'Avenir';
	font-size: 16px;
	color: var(--neutral-800);
}

.token-logo {
	width: 90px;
	height: 90px;
	border-radius: 50%;
	background-color: rgba($pronto-green, 0.1);
	align-self: center;
	display: flex;

	:deep(svg) {
		align-self: center;
		height: 85px;
		width: 85px;
	}
}

.pronto-input {
	cursor: pointer;
	:deep(input) {
		width: calc(100% - 40px) !important;
		flex-grow: unset !important;
		cursor: pointer !important;
	}
}

.copy-icon {
	border-left: 1px solid var(--neutral-40040);
	height: 40px;
	padding: 0 12px;
	&:hover {
		color: $pronto-green;
	}
	:deep(svg) {
		flex-shrink: 0 !important;
	}
}
</style>
<style lang="scss">
.show-token-modal {
	.modal-content {
		height: 470px !important;
	}

	.show-token {
		display: flex;
		flex-direction: column;
		text-align: center;
		padding: 24px;
	}

	.help {
		max-width: 461px;
		margin-top: 16px;
		font-family: 'Avenir-Medium';
		font-size: 16px;
		color: var(--neutral-600);
	}

	.input-container .input-content {
		border-color: var(--teal-300);
	}

	.copy-wrapper .copy-icon {
		border-color: var(--teal-300);
	}
}
</style>
